export default {
  LEARNING_PATHS_UPDATED: (state, learningPaths) => {
    state.learningPaths = learningPaths
  },

  SELECTED_LEARNING_PATH_UPDATED: (state, selectedLearningPath) => {
    state.selectedLearningPath = selectedLearningPath
  },
}
